import { Box, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { Modal } from "@outschool/ui-legacy-component-library";
import React from "react";

import { SearchInputField } from "./SearchInputField";

export function SearchInputModal(props: $TSFixMe) {
  const {
    children,
    filterIcon,
    filterDisplayValue,
    filterPlaceholder,
    filterValue,
    onClose,
    open,
  } = props;

  const { t } = useTranslation(
    "client\\components\\search\\mobile\\SearchInputModal",
  );

  const onClick = () => {
    const { open, onClose, onOpen } = props;
    if (open) {
      onClose();
    } else {
      onOpen();
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <SearchInputField
        icon={filterIcon}
        placeholder={filterPlaceholder}
        value={!!filterDisplayValue ? filterDisplayValue : filterValue}
        onClick={onClick}
      />
      {open && (
        <SearchInputModalOverlay onClose={onClose}>
          <Typography variant="h3">{t("Filters")}</Typography>
          {children}
        </SearchInputModalOverlay>
      )}
    </Box>
  );
}

export function SearchInputModalOverlay({
  children,
  onClose = () => {},
}: $TSFixMe) {
  return (
    <Modal open onClose={onClose} closeViaEscButton sx={{ padding: "medium" }}>
      <Box
        sx={{
          padding: "1em 1em 100px 1em",
        }}
      >
        {children}
      </Box>
    </Modal>
  );
}
